<div
  class="repeat-wrapper"
  [ngClass]="field.templateOptions?.['variant'] ? 'repeat-' + field.templateOptions?.['variant'] : ''"
  [class.repeat-wrapper--header-action]="field.templateOptions?.['addPlacement'] === 'header'"
>
  <div
    *ngIf="!field.fieldGroup?.length && field.templateOptions?.['emptyText']"
    class="repeat-empty"
  >
    <mat-icon
      aria-hidden="true"
      >{{ field.templateOptions?.['emptyIcon'] || 'playlist_add' }}</mat-icon
    >
    <span>{{ field.templateOptions?.['emptyText'] }}</span>
  </div>

  <div class="repeat-item" *ngFor="let f of field.fieldGroup; let i = index">
    <div class="item-header" *ngIf="field.templateOptions?.['itemLabel']">
      <div class="item-heading">
        <span class="item-index">{{ i + 1 }}</span>
        <div>
          <div class="item-title">{{ field.templateOptions?.['itemLabel'] }} {{ i + 1 }}</div>
          <div class="item-description" *ngIf="field.templateOptions?.['itemDescription']">
            {{ field.templateOptions?.['itemDescription'] }}
          </div>
        </div>
      </div>
      <button
        mat-icon-button
        type="button"
        class="delete-btn"
        [attr.aria-label]="'Remove ' + field.templateOptions?.['itemLabel'] + ' ' + (i + 1)"
        (click)="remove(i)"
      >
        <mat-icon>delete_outline</mat-icon>
      </button>
    </div>
    <div class="item-content">
      <formly-field [field]="f"></formly-field>
    </div>
    <button
      *ngIf="!field.templateOptions?.['itemLabel']"
      mat-icon-button
      type="button"
      class="delete-btn"
      aria-label="Remove"
      (click)="remove(i)"
    >
      <mat-icon>delete</mat-icon>
    </button>
  </div>

  <div class="repeat-actions">
    <button mat-stroked-button color="primary" type="button" (click)="add()">
      <mat-icon
        *ngIf="field.templateOptions?.['addIcon']"
        >{{ field.templateOptions?.['addIcon'] }}</mat-icon
      >
      {{ field.templateOptions?.['addText'] || 'Add' }}
    </button>
  </div>
</div>
